var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75588 31L6.17616 24.4271C4.35068 21.5571 3.63855 18.1217 4.17339 14.7656C4.70823 11.4095 6.45328 8.36318 9.08113 6.1983C11.709 4.03342 15.039 2.89872 18.4465 3.0071C21.854 3.11548 25.1047 4.45949 27.5887 6.78696C30.0728 9.11443 31.6194 12.2654 31.9385 15.6487C32.2576 19.032 31.3272 22.4151 29.3219 25.1633C27.3165 27.9114 24.3741 29.8358 21.0466 30.5753C17.7191 31.3148 14.2352 30.8186 11.2486 29.1798L4.75588 31Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3613 19.4009C22.0625 19.1988 21.7636 19.0978 21.4648 19.5019L20.2694 21.1186C19.9706 21.3207 19.7714 21.4217 19.3729 21.2196C17.8788 20.4113 15.7869 19.5019 13.9939 16.4707C13.8943 16.0665 14.0935 15.8644 14.2927 15.6624L15.1892 14.2478C15.3884 14.0457 15.2888 13.8436 15.1892 13.6415L13.9939 10.7113C13.695 9.903 13.3962 10.004 13.0974 10.004H12.3005C12.1012 10.004 11.7028 10.1051 11.3043 10.5092C9.11288 12.7322 10.0094 15.8644 11.6032 17.8853C11.902 18.2894 13.8943 21.9269 18.1776 23.8467C21.3652 25.2613 22.0625 25.0592 22.959 24.8571C24.0547 24.7561 25.1504 23.8467 25.6485 22.9373C25.7481 22.6342 26.2462 21.3207 25.8477 21.1186",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappicon1);
export default __webpack_public_path__ + "static/media/whatsapp icon (1).885a46fbb7fbd765f23d73cfcb1b17cc.svg";
export { ForwardRef as ReactComponent };